import { render, staticRenderFns } from "./TukiosastonHarjoitukset.vue?vue&type=template&id=f68c1008&scoped=true"
import script from "./TukiosastonHarjoitukset.vue?vue&type=script&lang=js"
export * from "./TukiosastonHarjoitukset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68c1008",
  null
  
)

export default component.exports